module.exports = __webpack_public_path__ + "img/trophy_inner2.606dca1a.png";